module.exports = __webpack_public_path__ + "img/cww_01.bb88af3c.jpg";